import { Injectable } from '@angular/core';
import { FiDialogsService } from '../fi-dialogs';
import {
    FiRenameWidgetDialogComponent,
    IRenameWidgetDialogData,
} from './fi-rename-widget-dialog/fi-rename-widget-dialog.component';
import { AppTextService } from '../app-text';
import { IFiDialogResult } from '../fi-dialogs/fi-dialogs';
import {
    FiReportWidgetNewWidgetTypeSelectStepComponent,
    IAvailableReportWidget,
} from './new-report-widget-dialog/new-widget-type-select-step/new-widget-type-select-step.component';

@Injectable()
export class FiReportWidgetDialogsService {
    constructor(
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
    ) {}

    getRenameWidgetDialog(widgetName: string, widgetDescription: string): IFiDialogResult<IRenameWidgetDialogData> {
        return this.fiDialogsService.custom({
            contentComponentRef: FiRenameWidgetDialogComponent,
            contentComponentData: {
                widgetName,
                widgetDescription,
            },
            isBigSizeTopBorder: true,
            headerIconClass: 'far fa-pen-line BrandedColor',
            headerText: this.appTextService.get('widget.rename_widget'),
            yesButtonText: this.appTextService.get('common.save'),
            noButtonText: this.appTextService.get('common.cancel'),
            preventUppercaseButtonLabel: true,
            config: {
                panelClass: 'fi-rounded-dialog-panel',
                autoFocus: false,
                restoreFocus: false,
                maxWidth: 'fit-content',
            },
        });
    }

    getConfirmWidgetDeleteDialog(): IFiDialogResult<unknown> {
        return this.fiDialogsService.confirm({
            colorClass: 'red',
            headerText: this.appTextService.get('checklist.delete_report_widget'),
            headerIconClass: 'fa-light fa-trash red',
            isTopCloseButtonShown: true,
            messageText: this.appTextService.get('checklist.delete_report_widget_message'),
            yesButtonText: this.appTextService.get('common.delete'),
            preventUppercaseButtonLabel: true,
            config: {
                panelClass: 'fi-rounded-dialog-panel',
                autoFocus: false,
                restoreFocus: false,
            },
        });
    }

    getNewWidgetTypeSelectDialog(
        availableReportWidgetsData: IAvailableReportWidget[],
        preventExtraPadding?: boolean,
    ): IFiDialogResult<number> {
        return this.fiDialogsService.custom({
            contentComponentRef: FiReportWidgetNewWidgetTypeSelectStepComponent,
            contentComponentData: {
                availableReportWidgetsData: availableReportWidgetsData,
                preventExtraPadding: preventExtraPadding,
            },
            headerIconClass: 'far fa-grid-2-plus BrandedColor',
            headerText: this.appTextService.get('checklist.checklist_report_new_widget_dialog_heading'),
            isHeaderDividerShown: true,
            hideDialogTopBorder: true,
            noButtonText: this.appTextService.get('common.cancel'),
            preventUppercaseButtonLabel: true,
            isYesButtonHidden: true,
            config: {
                panelClass: ['fi-rounded-dialog-panel', 'fi-new-widget-dialog-panel'],
                autoFocus: false,
                restoreFocus: false,
                minWidth: '500px',
            },
        });
    }
}
